import React from 'react'
import Close from "../../images/close.svg"
import Lottie from "lottie-react";
import { payment_fail, payment_success } from '../../Lottie/payment';
 
function SuccessEvent(props) {
    const{navigate, status} = props

  return (
    <div className="success-section flex-col  -translate-x-1/2">
        <button onClick={()=>navigate()} className="absolute top-6 right-6  w-6 h-6 rounded-full flex justify-center items-center bg-gray-50"><img className='w-6' src={Close} alt="" /></button>
        <Lottie className='md:w-[150px]' animationData={status == "success" ?  payment_success  :payment_fail} loop={false}/>
        {status == "success" ?  <div className="text-green-500 mt-4">Booking Success!</div> :<div className="text-orange-500">Booking failed  ⚠</div> }
     </div>
)
}

export default SuccessEvent